import React, { useEffect, useState } from "react";
import { Button, Label, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { toast } from "react-toastify";
import { Trash, Edit } from "react-feather";

import { updateCustomer } from "services/api";
import { MySpinner } from "components/MySpinner";
import { Cut } from "components/Cut";
import { TableButton } from "components/TableButton";
import { CloseButton } from "components/CloseButton";
import { SelectSearch } from "components/SelectSearch";
import { priceListSuggestion } from "services/apiSupply";

import { markupRender } from "../MarkupBrand/MarkupRender";
import { MarkupModal } from "../MarkupModal";
import { MarkupBrand } from "../MarkupBrand";

import "./markupPriceList.scss";

export const MarkupPriceList = ({ values }) => {
  const [addRuleShown, setAddRuleShown] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [markup, setMarkup] = useState(null);
  const [markups, setMarkups] = useState([]);
  const [priceList, setPriceList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [markupBrand, setMarkupBrand] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const markupHandler = (markup) => {
    setMarkup(markup);
    setOpenModal(false);
  };

  const removeMarkupHandler = (id) => {
    setLoading(true);

    const newMarkupProvider = [...values?.markupPriceList];

    updateCustomer({
      id: values.id,
      markupPriceList: newMarkupProvider.filter(v => v.id !== id)
    })
      .then((res) => {
        setMarkups(res.markupPriceList);
        toast.success("Изменения успешно сохранены");
        setAddRuleShown(false);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const openModalEdit = (id) => {
    setAddRuleShown(true);
    setIsEdit(true);
    const markupPriceListOne = markups.filter(v => v.id === id)[0];
    setMarkup(markupPriceListOne.markup);
    setPriceList({ label: markupPriceListOne.name, value: markupPriceListOne.id });
    setMarkupBrand(markupPriceListOne.markupBrand);
  }

  const openModalAdd = () => {
    setMarkup(null);
    setPriceList(null);
    setMarkupBrand([]);
    setAddRuleShown(true);
  }

  useEffect(() => {
    setMarkups(values.markupPriceList);
  }, [values]);

  useEffect(() => {
    if (addRuleShown === false) {
      setIsEdit(false);
    }
  }, [addRuleShown]);

  const addRuleHandler = () => {

    if (markups.find(v => v.id === priceList.value && v.markup === markup.id)) {
      toast.error("Такое правило уже существует");
      return;
    }
    setLoading(true);
    updateCustomer({
      id: values.id,
      markupPriceList: [
        ...markups,
        {
          id: priceList.value,
          name: priceList.label,
          markup,
          markupBrand: markupBrand
        }
      ]
    })
      .then((res) => {
        setMarkups(res.markupPriceList);
        toast.success("Изменения успешно сохранены");
        setAddRuleShown(false);
        setPriceList(null);
        setMarkup(null);
        setMarkupBrand([]);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  const updateRuleHandler = () => {
    setLoading(true);
    const newMarkupProvider = [...values?.markupPriceList];
    const index = newMarkupProvider.findIndex(v => v.id === priceList.value);

    newMarkupProvider[index] = {
      id: priceList.value,
      name: priceList.label,
      markup,
      markupBrand: markupBrand
    };

    updateCustomer({
      id: values.id,
      markupPriceList: newMarkupProvider
    })
      .then((res) => {
        setMarkups(res.markupPriceList);
        toast.success("Изменения успешно сохранены");
        setAddRuleShown(false);
        setPriceList(null);
        setMarkup(null);
        setMarkupBrand([]);
        setIsEdit(false);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="markupPriceList">
      {loading && <MySpinner overlay />}
      <div className="react-bootstrap-table p-0">
        <Table className="table table-hover">
          <thead>
            <tr>
              <th style={{ width: "40%" }}>Прайс лист</th>
              <th style={{ width: "30%" }}>Наим.наценки</th>
              <th style={{ width: "30%" }}>Бренды</th>
              <th style={{ width: "8%" }}></th>
              <th style={{ width: "8%" }}></th>
            </tr>
          </thead>
          <tbody>
            {markups.map((item) =>
              <tr key={`${item.id}${item.markup}`}>
                <td><Cut>{item.name}</Cut></td>
                <td>
                  <Cut>{item.markup?.name}</Cut>
                </td>
                <td>
                  <Cut>{item.markupBrand.map(brand => `${brand.name} `)}</Cut>
                </td>
                <td>
                  <TableButton
                    Icon={Edit}
                    onClick={() => openModalEdit(item.id)}
                  />
                </td>
                <td>
                  <TableButton
                    Icon={Trash}
                    onClick={() => removeMarkupHandler(item.id)}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <Modal
        isOpen={addRuleShown}
        toggle={() => setAddRuleShown(false)}
        className="markup-modal"
      >
        {loading && <MySpinner overlay />}
        <div className="ruleBlock">
          <ModalHeader>
            <div className="modal-title-text">
              {isEdit ?
                `Редактирование наценки на прайс-лист ${priceList?.label}`
                : 'Новое правило наценки на прайс-лист'
              }

            </div>
            <CloseButton onClick={() => setAddRuleShown(false)} />
          </ModalHeader>
          <ModalBody className=" m-3">
            <div className="top mt-2">
              <Label>Прайс лист</Label>
              <SelectSearch
                name="priceList"
                placeholder="Выберите прайс лист"
                functionSuggestion={priceListSuggestion}
                value={priceList}
                setValue={setPriceList}
                isDisabled={isEdit}
              />
              <div className="mt-2">
                <Label>Наценка</Label>
                {markup ?
                  <div className="selectedMarkup">
                    <b>{markup.name}:</b> {markupRender(markup.markup)}
                  </div>
                  : <div className="selectedMarkup">Не выбрана наценка</div>}
              </div>
              <Button onClick={() => setOpenModal(true)} color="primary" className="mt-2">
                Выбрать наценку
              </Button>
            </div>

            <MarkupBrand setMarkupBrand={setMarkupBrand} markupBrand={markupBrand} />
            <div className="d-flex justify-content-end">
              <Button onClick={() => { isEdit ? updateRuleHandler() : addRuleHandler() }} color="primary" className="mt-2" disabled={!priceList || !markup}>
                Сохранить правило
              </Button>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Button onClick={() => openModalAdd()} color="primary" className="mt-2">
        Добавить правило
      </Button>

      <MarkupModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        onClick={markupHandler}
      />
    </div>
  );
}